import { ChangeType } from "@zapier/checkout/esm/types";

import { getChangeLabel } from "../getChangeLabel";

export const getChangeLabelForPlanName = (
  changeType: ChangeType,
  planName: string
): string => {
  const changeLabel = getChangeLabel(changeType);

  if (changeType === "change") {
    return `${changeLabel} billing for ${planName} plan`;
  }

  return `${changeLabel} to ${planName} plan`;
};
